/**
 * mutation types
 */

// 更新loading状态
export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS';
// 更新列表
export const UPDATE_LIST = 'UPDATE_LIST';
// 更新额外信息
export const UPDATE_EXTRA_INFO = 'UPDATE_EXTRA_INFO';
// 更新请求queries
export const UPDATE_REQUEST_QUERIES = 'UPDATE_REQUEST_QUERIES';
// 更新详情
export const UPDATE_DETAIL = 'UPDATE_DETAIL';

// 更新用户信息
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
